<app-header>
    <div class="card p-5">
      <div class="card-body" class="text-center">
        <h2 class="title text-primary">Feed Type Not Supported</h2>
        <p class="body-text mt-4">
            This feed type does not have a supported display available at this time.
        </p>
        <p class="body-text text-primary mt-4"><b>COMING SOON!</b></p>
      </div>
    </div>
  </app-header>
  